import React from "react";
import { useDispatch } from "react-redux";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { removedDocumentDraftHandled } from "store/actions/documentDraftActions";
import { ImageMeta } from "models/propTypes/fileViewerPropTypes";
//endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { TitledContainerInner, EntityCardContent, FileViewerContainer, PageFooter } from "components/common";
import { useDocumentDraftService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const RemovedDocumentDraftTodo: React.FC<TodoCardProps> = (props) => {
  const documentDraft = props.item.documentDraft;

  const dispatch = useDispatch();
  const documentDraftService = useDocumentDraftService();

  const [attachments, setAttachments] = React.useState<ImageMeta[]>([]);

  React.useEffect(() => {
    if (documentDraft) {
      const attachments =
        documentDraft.attachments?.map<ImageMeta>((meta) => ({
          id: meta.id,
          contentType: meta.contentType,
          fileName: meta.fileName,
          numberOfPages: 1,
        })) ?? [];
      setAttachments(attachments);

      documentDraft.attachments?.forEach((attachment) => {
        documentDraftService.getAttachmentData(documentDraft.id, attachment.id).then((res) => {
          setAttachments((prevAttachments) => {
            const newAttachments = prevAttachments.map((p) => ({ ...p }));
            const attachmentToUpdate = newAttachments.find((a) => a.id === attachment.id);
            if (attachmentToUpdate) {
              attachmentToUpdate.data = res;
            }
            return newAttachments;
          });
        });
      });
    }
  }, [documentDraft?.attachments]);

  const documentDraftSubject =
    documentDraft?.subject ??
    attachments[0]?.fileName ??
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.NoSubject);

  const documentDraftFromMessage = documentDraft?.from
    ? `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.SentBy)}: ${documentDraft.from}`
    : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.NoSender);

  const onHandledSuccess = React.useCallback(() => {
    dispatch(removedDocumentDraftHandled(documentDraft!.id));
    props.onActionSuccess && props.onActionSuccess();
  }, [documentDraft, props.onActionSuccess]);

  const markAsRead = React.useCallback(
    () => documentDraftService.handleRemovedDraft(documentDraft!.id),
    [documentDraft]
  );

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingTwo={documentDraftSubject}
          descriptionheadingThree={documentDraftFromMessage}
          footerText={`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.DocumentDraft.Received
          )}: ${LocalizationHelperInstance.getFormattedDate(documentDraft!.created)}`}
          noDescriptionTextWrap
        />
      }
      todoMainSection={
        <TitledContainerInner
          header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.RemovedTodoTitle)}
          subHeader={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.RemovedTodoText1)}
        >
          <p>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.RemovedTodoText2)}</p>
        </TitledContainerInner>
      }
      infoViewer={
        attachments.length ? (
          <FileViewerContainer
            key={documentDraft?.id}
            meta={attachments}
            parentId={documentDraft?.id ?? 0}
            loading={documentDraft === undefined}
          />
        ) : (
          <></>
        )
      }
      footer={
        <PageFooter
          actions={[
            {
              text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.MarkAsRead),
              onClick: markAsRead,
              type: StyleEnums.DisplayType.Info,
              onActionSuccess: onHandledSuccess,
            },
          ]}
        />
      }
    />
  );
};

export default RemovedDocumentDraftTodo;
